import React, { useEffect, useState } from "react";
import { Alert, Box, Button, FormControl, FormLabel, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { addUserToDocUserGroup ,useLazyGetNPINumberQuery } from "../../redux/slices/physician/physicianThunk";
import { useDispatch } from "react-redux";

//Component that uses MUI components to create a form for the user to input their NPI number, name
//This component is used in the NPIFormDialog component
const NPIForm = () => {
    const theme = useTheme();
    const onMobile = !useMediaQuery('(min-width:600px)');
    
    const dispatch = useDispatch();

    const [npi, setNPI] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [npiError, setNPIError] = useState(false);
    const [firstNameError, setFirstNameError] = useState(false);
    const [lastNameError, setLastNameError] = useState(false);
    const [npiHelperText, setNPIHelperText] = useState("");
    const [nameHelperText, setNameHelperText] = useState("");

    const [trigger, { data, error, isLoading }] = useLazyGetNPINumberQuery();

    const textFieldStylesOne = { margin: theme.spacing(1), width: "96%" };
    const textFieldStylesTwo = { margin: theme.spacing(1), width: "60%" };

    useEffect(() => {
        const handleEnter = (e) => {
            if (e.key === "Enter") {
                handleSubmit(e);
            }
        };
        window.addEventListener("keydown", handleEnter);
        return () => window.removeEventListener("keydown", handleEnter);
    }, [npi, firstName, lastName]);

    // useEffect(() => {}, [personInfo])

    //Function that is called when the user submits the form
    const handleSubmit = async (e) => {
        e.preventDefault();
        //If the NPI number is not valid, set the error state to true and display an error message
        if (!npi || npi.length !== 10) {
            setNPIError(true);
            setNPIHelperText("Please enter a valid NPI number");
        } else {
            setNPIError(false);
            setNPIHelperText("");
        }
        //If the name is not valid, set the error state to true and display an error message
        if (!firstName) {
            setFirstNameError(true);
            setNameHelperText("Please enter your first name");
        } else {
            setFirstNameError(false);
            setNameHelperText("");
        }
        if (!lastName) {
            setLastNameError(true);
            setNameHelperText("Please enter your last name");
        } else {
            setLastNameError(false);
            setNameHelperText("");
        }

        const doctorFound = await checkNPINumber();
        //If all fields are valid, dispatch the setNPI action with the NPI number, name
        if (npi && npi.length === 10 && firstName && firstName && lastName && doctorFound) {
            dispatch(addUserToDocUserGroup());
        }
    };

    const checkNPINumber = async () => {
        try {
            const doctorFound = await trigger({ npi, firstName, lastName }).unwrap();
            console.log(doctorFound)
            return doctorFound;
        } catch(e) {
            console.error(e);
            return false;
        }
    }


    return (
        //Create form using MUI FormControl component
            <FormControl style={{ 
                display: "flex", 
                flexDirection: "column", 
                alignItems: "center", 
                justifyContent: "center", 
                height: "100vh", 
                marginTop: "-1rem"
            }}>
                <FormLabel sx={{
                    position: "absolute",
                    top: "6rem",
                    maxWidth: "50rem",
                }}>
                    <Typography sx={{
                            padding: "2rem 3rem 0rem 3rem",
                            fontSize: !onMobile ? "1.8em" : "1.75em",
                            fontWeight: "bold",
                            textAlign: "center",
                            width: "100%",
                    }}>
                        Please verify you are a physician by entering your NPI number, first name, and last name
                    </Typography>
                </FormLabel>                
                <Box sx={{display: "flex", flexDirection: "column", minWidth: "15rem", maxWidth: "35rem", width: "90%"}}>
                    <Box sx={{
                        display: (error && !lastNameError && !firstNameError && !npiError) ? "block" : "none",
                        width: "100%",
                        maxWidth: "50rem",
                        padding: "10px",
                    }}>
                    <Alert severity="error">
                        Physician with the given information does not exist. Please try again.
                    </Alert>
                    </Box>
                    <Box sx={{display: "flex", flexDirection: "row"}}>
                        <TextField
                            error={firstNameError}
                            helperText={nameHelperText}
                            label="First Name"
                            variant="outlined"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            style={textFieldStylesTwo}
                        />
                        <TextField
                            error={lastNameError}
                            helperText={nameHelperText}
                            label="Last Name"
                            variant="outlined"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            style={textFieldStylesTwo}
                        />
                    </Box>
                    <Box sx={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                        <TextField
                            error={npiError}
                            helperText={npiHelperText}
                            label="NPI Number"
                            variant="outlined"
                            value={npi}
                            onChange={(e) => setNPI(e.target.value)}
                            style={textFieldStylesOne}
                        />
                        <Button 
                            variant="contained" 
                            color="caralystNavy" 
                            onClick={async (e) => await handleSubmit(e)}
                            sx={{
                                color: 'white',
                                textTransform: 'none',
                                height: `calc(100% - ${theme.spacing(2)})`,
                                margin: theme.spacing(1),
                        }}>
                            Submit
                        </Button>
                    </Box>
                </Box>
            </FormControl>
    );
}

export default NPIForm;
